// Template197: Bangkok - Rooftop (Día 3). Idéntico a PageRooftop.jsx. borderRadius: "12px".

import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { useWindowSize } from "@uidotdev/usehooks";
import { useMapFullscreen } from "../../context/MapFullscreenContext";
import SabiasQue from "../SabiasQue";

const Template197 = ({
	backgroundColor,
	headerBackgroundColor,
	headerTextColor,
	fontFamily,
	page,
}) => {
	const size = useWindowSize();
	const isSmallScreen = size.width <= 600;
	const [mapLoaded, setMapLoaded] = useState(false);
	const [fullscreen, setFullscreen] = useState(false);
	const { setMapFullscreen } = useMapFullscreen() || {};

	const headerText = page?.texts?.[0]?.content ?? "Día 3: Contrastes urbanos";
	const intro = page?.texts?.[1]?.content;
	const boxTitle = page?.texts?.[2]?.content ?? "ROOFTOP BARS POPULARES";
	const boxP1 = page?.texts?.[3]?.content;
	const boxP2 = page?.texts?.[4]?.content;
	const boxP3 = page?.texts?.[5]?.content;
	const boxP4 = page?.texts?.[6]?.content;

	const mapEmbedUrl = page?.data?.mapEmbedUrl;

	const getImageSrc = (id) => {
		if (page?.images && Array.isArray(page.images)) {
			const found = page.images.find((img) => img?.id === id);
			if (found?.src) return found.src;
		}
		return undefined;
	};
	const getCanvasImageUrl = (id) => {
		if (page?.canvasImages && Array.isArray(page.canvasImages)) {
			const found = page.canvasImages.find((img) => img?.id === id);
			if (found?.imageUrl) return found.imageUrl;
		}
		return undefined;
	};

	const stickerUrl = getCanvasImageUrl("sticker");
	const logoImage = getCanvasImageUrl("logo");
	const sabiasQue = Array.isArray(page?.data?.sabiasQue)
		? page.data.sabiasQue
		: [];
	const actualHeaderColor = headerBackgroundColor || "#E8A838";

	const h4Amarillo = {
		margin: "0 0 8px 0",
		fontSize: "13px",
		fontWeight: 700,
		color: "#E8A838",
		textTransform: "uppercase",
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
	};
	const estiloP = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#000",
		margin: 0,
	};
	const p = {
		fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
		fontSize: "13px",
		color: "#444",
		margin: 0,
	};

	useEffect(() => {
		const style = document.createElement("style");
		style.innerHTML = `@keyframes template197-spin { 0% { transform: rotate(0deg); } 100% { transform: rotate(360deg); } }`;
		document.head.appendChild(style);
		return () => document.head.removeChild(style);
	}, []);

	useEffect(() => {
		if (typeof setMapFullscreen === "function") {
			setMapFullscreen(fullscreen);
			return () => setMapFullscreen(false);
		}
	}, [fullscreen, setMapFullscreen]);

	if (fullscreen && mapEmbedUrl) {
		return (
			<Box
				sx={{
					position: "fixed",
					top: 0,
					left: 0,
					right: 0,
					bottom: 0,
					backgroundColor: "#fff",
					zIndex: 9999,
					display: "flex",
					flexDirection: "column",
				}}
			>
				<Box
					sx={{
						padding: "10px",
						textAlign: "right",
						backgroundColor: actualHeaderColor,
					}}
				>
					<Box
						component="button"
						onClick={() => setFullscreen(false)}
						sx={{
							backgroundColor: "#fff",
							color: actualHeaderColor,
							border: "none",
							borderRadius: "8px",
							padding: "6px 12px",
							fontWeight: 600,
							cursor: "pointer",
						}}
					>
						← Volver a la guía
					</Box>
				</Box>
				<Box
					component="iframe"
					title="Mapa grande Rooftop"
					src={mapEmbedUrl}
					width="100%"
					sx={{ border: 0, flex: 1 }}
					allowFullScreen
					loading="lazy"
				/>
			</Box>
		);
	}

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				minHeight: "100%",
				backgroundColor: backgroundColor || "#f7f7f7",
				position: "relative",
				fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				"& *": {
					fontFamily: `${fontFamily || "'Poppins', sans-serif"} !important`,
				},
			}}
		>
			<Box
				data-block-id="header"
				data-template-header
				sx={{
					backgroundColor: actualHeaderColor,
					color: headerTextColor || "#fff",
					textAlign: "center",
					padding: "15px 0",
					fontSize: "14px",
					fontWeight: 600,
					flexShrink: 0,
					position: "sticky",
					top: 0,
					zIndex: 1,
				}}
			>
				{headerText}
				{logoImage && (
					<Box
						component="img"
						src={logoImage}
						alt=""
						sx={{
							width: isSmallScreen ? 66 : 80,
							position: "absolute",
							right: 2,
							top: 18,
							zIndex: 999999,
						}}
					/>
				)}
			</Box>

			<Box
				data-block-id="map"
				sx={{
					flex: 1,
					minHeight: 400,
					marginTop: "-70px",
					position: "relative",
					display: "flex",
					flexDirection: "column",
				}}
			>
				{stickerUrl && (
					<Box
						component="img"
						src={stickerUrl}
						alt=""
						sx={{ width: 90, position: "absolute", bottom: -10, left: 0 }}
					/>
				)}
				{mapEmbedUrl && !mapLoaded && (
					<Box
						sx={{
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							position: "absolute",
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							zIndex: 1,
						}}
					>
						<Box
							sx={{
								width: 20,
								height: 20,
								border: "4px solid #ccc",
								borderTop: "4px solid #E8A838",
								borderRadius: "50%",
								animation: "template197-spin 1s linear infinite",
							}}
						/>
					</Box>
				)}
				{mapEmbedUrl && (
					<>
						<Box
							component="button"
							onClick={() => setFullscreen(true)}
							sx={{
								position: "absolute",
								top: 80,
								right: 10,
								backgroundColor: actualHeaderColor,
								color: "#fff",
								padding: "8px 10px",
								fontSize: "11px",
								borderRadius: "8px",
								boxShadow: "1px 1px 2px rgba(0,0,0,0.2)",
								zIndex: 4,
								border: "none",
								cursor: "pointer",
							}}
						>
							Ver mapa grande
						</Box>
						<Box
							component="iframe"
							title="Mapa Rooftop bars Bangkok"
							src={mapEmbedUrl}
							loading="lazy"
							sx={{ border: 0, flex: 1, minHeight: 400, width: "100%" }}
							onLoad={() => setMapLoaded(true)}
						/>
					</>
				)}
			</Box>

			<Box data-block-id="text-1" sx={{ padding: "10px 12px" }}>
				{intro && (
					<Box component="p" sx={p}>
						{intro}
					</Box>
				)}
			</Box>

			<Box data-block-id="text-2" sx={{ padding: "0 12px", marginBottom: 1.5, position: "relative" }}>
				{sabiasQue.length > 0 && (
					<Box
						sx={{
							padding: "0 12px",
							marginBottom: 2,
							position: "absolute",
							top: 0,
							left: isSmallScreen ? "57%" : "50%",
						}}
					>
						<SabiasQue
							icono={sabiasQue[0]?.icono ?? "👔"}
							texto={sabiasQue[0]?.texto ?? ""}
						/>
					</Box>
				)}
				<Box
					sx={{
						backgroundColor: "#FFF3CD",
						border: "3px solid #E8A838",
						borderRadius: "12px",
						padding: "12px 16px",
						fontSize: "12px",
						color: "#333",
						width: "100%",
					}}
				>
					<Box component="h4" sx={h4Amarillo}>
						{boxTitle}
					</Box>
					{boxP1 && (
						<Box
							component="p"
							sx={{ margin: "0 0 8px 0", ...estiloP }}
							dangerouslySetInnerHTML={{ __html: boxP1 }}
						/>
					)}
					{boxP2 && (
						<Box
							component="p"
							sx={{ margin: "0 0 8px 0", ...estiloP }}
							dangerouslySetInnerHTML={{ __html: boxP2 }}
						/>
					)}
					{boxP3 && (
						<Box
							component="p"
							sx={{ margin: "0 0 8px 0", ...estiloP }}
							dangerouslySetInnerHTML={{ __html: boxP3 }}
						/>
					)}
					{boxP4 && (
						<Box
							component="p"
							sx={{ margin: 0, ...estiloP }}
							dangerouslySetInnerHTML={{ __html: boxP4 }}
						/>
					)}
				</Box>
			</Box>
		</Box>
	);
};

Template197.thumbnail = "/images/template-1.png";
export default Template197;
